// Checklist: studioaeye-backend/docs/tests-Backend/testingCheckList.md
// Feature: M001-F0213 (device-link approval, web slice) / Mantis #1436
//
// Display metadata for the /Service-Link device-link approval screen.
//
// Spec provenance: interfaces/core-service-link/v2 (Spec#1150, Spec main
// commit 32c50b53) defines `app_code` as exactly this closed enum and
// carries NO display metadata (no name, no icon). The names/icons below
// are therefore vendored WebUI-side and are keyed strictly on the Spec's
// AppCode enum values. An app_code outside the enum resolves to the
// "Unknown app" fallback — the screen never guesses a friendlier name
// for a code the Spec does not define.

export const SERVICE_LINK_APP_META = {
  choreo: { name: 'Choreo', icon: '💃' },
  ledger: { name: 'Ledger', icon: '📒' },
  mycelium: { name: 'Mycelium', icon: '🍄' },
  panoptes: { name: 'PanOptic', icon: '◉' },
  realmauthority: { name: 'RealmAuthority', icon: '🛡' },
  'receipt-ocr-runner': { name: 'Receipt Runner', icon: '🧾' },
};

export const UNKNOWN_SERVICE_LINK_APP = Object.freeze({
  name: 'Unknown app',
  icon: '❓',
  known: false,
});

export function getServiceLinkAppMeta(appCode) {
  const key = String(appCode || '').trim().toLowerCase();
  const entry = SERVICE_LINK_APP_META[key];
  if (!entry) {
    return { ...UNKNOWN_SERVICE_LINK_APP, code: key };
  }
  return { ...entry, code: key, known: true };
}
